import { render, staticRenderFns } from "./ThreadsTable.vue?vue&type=template&id=26506c67"
import script from "./ThreadsTable.vue?vue&type=script&lang=js"
export * from "./ThreadsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports